EmailFormIntlBaseDateInputView = require "./base_date_input_view.coffee"
Backbone = require 'backbone'
Backbone.$ = $

class EmailFormIntlDateTimeInputView extends EmailFormIntlBaseDateInputView
  tagName: 'li'

  events:
    'change .date_time_input': 'validateEmailForm'
    'keydown .date_time_input' : 'deleteKeyDownHandler'

  initialize: ->
    EmailFormIntlBaseDateInputView::initialize.apply(this, arguments)
    @elementID = ".date_time_input"
    @show_template = {date_time_input_template: true}
    @dropdownOptions = @getDropdownOptions(@model.additional_attributes.options) if @model.additional_attributes?.options?

  getDropdownOptions: (options)->
    dropdownOptions = []
    for option in options
      dropdownOptions.push({id: option, text: option})
    dropdownOptions

  getTimeSlotInputHtmlElement: ->
    @$el.find(".time_slot option:selected")

  readInput: ->
    date = @getInputHtmlElement().val().trim()
    slot = @getTimeSlotInputHtmlElement().text()
    "#{date} - #{slot}"

module.exports = EmailFormIntlDateTimeInputView
